import React from 'react'
import { NotificationContext } from '../../contexts'
import './Notification.scss'

enum NotificationType {
  SUCCESS = 'alert-success',
  ERROR = 'alert-danger',
}

export interface NotificationMessage {
  text: string
  type: NotificationType
  options?: NotificationOptions
}

export interface NotificationOptions {
  closeOnClick?: boolean
  showCloseButton?: boolean
}

const Notification: React.FunctionComponent<{}> = () => (
  <NotificationContext.Consumer>
    {({ notification, setNotification }) =>
      notification && (
        <div id="flashMessages" className="flash-messages" data-component="notification-component">
          <div
            className={`flash-message alert ${notification.type}`}
            onClick={() => {
              if (notification.options && notification.options.closeOnClick) {
                setNotification(null)
              }
            }}
          >
            {notification.options && notification.options.showCloseButton && (
              <button
                type="button"
                className="close"
                data-dismiss="alert"
                aria-label="Close"
                onClick={() => setNotification(null)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            )}
            <p>{notification.text}</p>
          </div>
        </div>
      )
    }
  </NotificationContext.Consumer>
)

export { Notification, NotificationType }
